export const PAYMENT_ACTION = {
    SubmitPay: "SubmitPay",
};

export const PAYMENT_STATUS = {
    SUCCESS: "SUCCESS",
    FAILED: "FAILED",
    PENDING: "PENDING"
};

export const PAYMENT_STATUS_CODE = {
    SUCCESS: 1,
    FAILED: 0,
    PENDING: 2
};

export const PAYMENT_STATUS_EVENT_TYPE = {
    Retry: 'failed-retry',
    Redirect: 'redirect',
};


export const PAYMENT_MODE = {
    FORWARD: "FORWARD",
    OUTPUT: "OUTPUT",
    REDIRECT: "REDIRECT",
};

export const PAY_METHOD = {
    CREDITCARD : "CREDITCARD",
}


export const JS_CLIENT_URL_DEV = "https://static.glocashier.com/v1/payment-client-1.0.4-sandbox.min.js?v=20250905-01"
export const JS_CLIENT_URL_UAT = "https://static.glocashier.com/v1/payment-client-1.0.4-sandbox.min.js?v=20250905-01"
export const JS_CLIENT_URL_PROD = "https://static.glocashier.com/v1/payment-client-1.0.3-production.min.js?v=20250714"

export const JS_CLIENT_CSS_DEV = "https://static.glocashier.com/v1/custom-date-cvv-inline.css"
export const JS_CLIENT_CSS_UAT = "https://static.glocashier.com/v1/custom-date-cvv-inline.css"
export const JS_CLIENT_CSS_PROD = "https://static.glocashier.com/v1/custom-date-cvv-inline.css"
